import { TrendingUp } from 'lucide-react';
import { DocPage } from '@/components/investor';
import { investorsSections, investorsStatus, investorsSummary, investorsTop } from '@/content/investors';

/**
 * Public investor overview, linked from the sidebar footer. Content lives in
 * src/content/investors.tsx, mirroring docs/investors/investors.md.
 */
export function InvestorsPage() {
  return (
    <DocPage
      badgeIcon={TrendingUp}
      badge="For Investors"
      title="The business becomes a service customers can talk to — and it finishes the job."
      status={investorsStatus}
      summary={investorsSummary}
      top={investorsTop}
      sections={investorsSections}
      contactEmail="investors@dialogme.ai"
      footer="Ask for the deck and the benchmark bundle. Financial scenarios and the funding model are shared on request."
    />
  );
}
